import { FunctionComponent } from "react";

import { TablePagination } from "@/components/TablePagination/TablePagination";

import { FEED_PAGE_SIZE } from "@/pages/Private/redux/feed/feed.api";

interface FeedPagerProps {
	page: number;
	pageCount: number;
	onPageChange: (page: number) => void;
}

/** Explicit pager under the card list (no infinite scroll on the Feed page). */
export const FeedPager: FunctionComponent<FeedPagerProps> = ({ page, pageCount, onPageChange }) => {
	if (pageCount <= 1) {
		return null;
	}

	return (
		<div className="flex justify-center py-3" data-testid="feed-pager">
			<TablePagination
				currentPage={page}
				handleNavigateToPage={onPageChange}
				limit={FEED_PAGE_SIZE}
				maxPage={pageCount}
			/>
		</div>
	);
};
